/* EasyKash "Pay online" for Cairo Shoes. Markup: snippets/cs-easykash-pay.liquid.
   Works for buttons rendered later too (the cart drawer is re-rendered by the theme). */
(function () {
  if (window.csEasyKashLoaded) return;
  window.csEasyKashLoaded = true;
  var sheets = {};

  function money(value) {
    var fmt = window.csMoneyFormat || ('LE {' + '{amount}}');
    var fixed = Number(value || 0).toFixed(2).split('.');
    var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + fixed[1])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, fixed[0] + ',' + fixed[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, fixed[0])
      .replace(/<[^>]*>/g, '');
  }
  function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function setup(root) {
    root.dataset.ready = '1';
    var mode = root.dataset.mode || 'cart';
    var key = root.dataset.key || mode;
    var sheet = root.querySelector('[data-cs-ek-sheet]');
    var opener = root.querySelector('[data-cs-ek-open]');
    if (!sheet || !opener) return;
    // the sheet lives at the end of <body> so a transformed cart drawer cannot trap it;
    // a re-rendered drawer brings a fresh sheet, so drop the old one
    if (sheets[key] && sheets[key] !== sheet && sheets[key].parentNode) sheets[key].parentNode.removeChild(sheets[key]);
    sheets[key] = sheet;
    document.body.appendChild(sheet);

    var form = sheet.querySelector('[data-cs-ek-form]');
    var msg = sheet.querySelector('[data-cs-ek-msg]');
    var go = sheet.querySelector('[data-cs-ek-go]');
    var codeInput = sheet.querySelector('[data-cs-ek-code]');
    var applyBtn = sheet.querySelector('[data-cs-ek-apply]');
    var codeMsg = sheet.querySelector('[data-cs-ek-codemsg]');
    var base0 = root.dataset.base;
    var applied = '';
    var timer;

    function show(text) { msg.textContent = text || ''; msg.hidden = !text; }
    function codeNote(text, ok) { codeMsg.textContent = text || ''; codeMsg.hidden = !text; codeMsg.classList.toggle('is-ok', !!ok); }

    function productItems() {
      var formId = root.dataset.form;
      var pform = formId && document.getElementById(formId);
      var input = pform && pform.querySelector('[name="id"]');
      var id = input && parseInt(input.value, 10);
      if (!id) return Promise.reject(new Error('Please choose your size first.'));
      var qtyInput = (formId && document.querySelector('input[name="quantity"][form="' + formId + '"]')) || (pform && pform.querySelector('input[name="quantity"]'));
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!(qty > 0)) qty = 1;
      return Promise.resolve([{ variant_id: id, quantity: Math.min(qty, 20) }]);
    }
    function items() {
      if (mode === 'product') return productItems();
      return fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return (cart.items || []).map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }); });
    }

    function applyCode() {
      var code = (codeInput.value || '').trim();
      applyBtn.disabled = true;
      codeNote('');
      items()
        .then(function (list) {
          return fetch(base0 + '/quote', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list, code: code }) });
        })
        .then(function (r) { return r.json(); })
        .then(function (q) {
          if (q.error) throw new Error(q.error);
          applied = q.applied ? q.code : '';
          sheet.querySelector('[data-cs-ek-sub]').textContent = money(q.subtotal);
          sheet.querySelector('[data-cs-ek-ship]').textContent = money(q.shipping);
          sheet.querySelector('[data-cs-ek-total]').textContent = money(q.total);
          var showDisc = q.discount > 0;
          sheet.querySelector('[data-cs-ek-dlabel]').hidden = !showDisc;
          var disc = sheet.querySelector('[data-cs-ek-disc]');
          disc.hidden = !showDisc;
          disc.textContent = showDisc ? '-' + money(q.discount) : '';
          if (q.applied) codeNote('Code ' + q.code + ' applied.', true);
          else if (code) codeNote(q.message || 'This code is not valid for your cart.');
        })
        .catch(function (err) { if (code || mode === 'product') codeNote(err && err.message ? err.message : 'Could not check the code. Please try again.'); })
        .then(function () { applyBtn.disabled = false; });
    }
    applyBtn.addEventListener('click', applyCode);
    codeInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyCode(); } });

    function open() {
      if (mode === 'product' && !(root.dataset.form && document.getElementById(root.dataset.form))) return;
      // a cart drawer opened as a modal <dialog> sits in the top layer above everything,
      // so close it first or the form would open hidden behind it
      var dlg = opener.closest('dialog[open]');
      if (dlg) { var drawer = dlg.closest('cart-drawer-component'); if (drawer && typeof drawer.close === 'function') drawer.close(); else dlg.close(); }
      applyCode();
      clearTimeout(timer);
      sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        sheet.classList.add('is-open');
        var first = form.querySelector('input[name="name"]');
        if (first) first.focus({ preventScroll: true });
      }); });
    }
    function close() {
      if (sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      timer = setTimeout(function () { sheet.hidden = true; }, 350);
      if (opener.isConnected) opener.focus({ preventScroll: true });
    }
    opener.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(); });
    sheet.querySelectorAll('[data-cs-ek-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (go.disabled) return;
      if (!form.reportValidity()) return;
      var data = {};
      new FormData(form).forEach(function (v, k) { data[k] = v; });
      delete data.code;
      if (applied) data.code = applied;
      go.disabled = true;
      go.textContent = 'Please wait…';
      show('');
      items()
        .then(function (list) {
          data.items = list;
          return fetch(base0 + '/checkout', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
        })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok || !res.body.url) throw new Error(res.body.error || 'We could not start the payment. Please try again.');
          if (mode === 'product') { window.location.href = res.body.url; return; }
          return fetch(shopRoot() + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
            .catch(function () {})
            .then(function () { window.location.href = res.body.url; });
        })
        .catch(function (err) {
          show(err && err.message ? err.message : 'We could not start the payment. Please try again.');
          go.disabled = false;
          go.textContent = 'Continue to payment';
        });
    });
  }

  function scan() { document.querySelectorAll('[data-cs-ek]:not([data-ready])').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
